import React from "react";

const CenterHover = () => (
  <div className="tooltip tooltip--center-view">
    <p className="tooltip__text" />
  </div>
);

export default CenterHover;
